module.exports = __webpack_public_path__ + "static/media/image_92.e9671b08.png";